/**
 * API клиент для AI чата
 */

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface ChatResponse {
  success: boolean;
  reply: string;
  suggestions?: Array<{
    text: string;
    type: string;
    path?: string;
  }>;
  error?: string;
}

export interface WelcomeResponse {
  success: boolean;
  reply: string;
  suggestions?: Array<{
    text: string;
    type: string;
  }>;
}

/**
 * Отправить сообщение в AI чат
 */
export async function sendChatMessage(
  message: string,
  userId?: number,
  history: ChatMessage[] = []
): Promise<ChatResponse> {
  try {
    const response = await fetch('/api/ai/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        message,
        userId,
        history
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('[AI Chat] Error sending message:', error);
    return {
      success: false,
      reply: 'Извините, произошла ошибка при отправке сообщения. Попробуйте еще раз.',
      error: error instanceof Error ? error.message : 'Unknown error'
    };
  }
}

/**
 * Получить приветственное сообщение
 */
export async function getWelcomeMessage(userId?: number): Promise<WelcomeResponse> {
  try {
    const url = userId ? `/api/ai/welcome?userId=${userId}` : '/api/ai/welcome';
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('[AI Chat] Error getting welcome:', error);
    return {
      success: false,
      reply: 'Здравствуйте! 👋\n\nЯ - AI помощник Level Sport Club. Задайте мне любой вопрос!',
      suggestions: [
        { text: 'Расписание', type: 'message' },
        { text: 'Записаться', type: 'message' }
      ]
    };
  }
}

/**
 * Проверить статус AI сервиса
 */
export async function checkAIStatus(): Promise<{ status: string; message: string }> {
  try {
    const response = await fetch('/api/ai/status');
    const data = await response.json();
    return {
      status: data.status || 'unknown',
      message: data.message || ''
    };
  } catch (error) {
    return {
      status: 'error',
      message: 'Could not connect to AI service'
    };
  }
}
